import React from "react";
import communityBg from "../../assets/img/color-bg.jpg";
import join1 from "../../assets/img/join-our-1.jpg";
import join2 from "../../assets/img/join-our-2.jpg";
import join3 from "../../assets/img/join-our-3.jpg";
import join4 from "../../assets/img/join-our-4.jpg";
import "./Community.css";

const Community = () => {
  return (
    <div>
      <section className="gap">
        <div className="container">
          <div
            className="join-our-community"
            style={{
              backgroundImage: `url(${communityBg})`,
            }}
          >
            <h2>Serving the community, working in partnership</h2>
            <p>
              We believe that our primary role is to serve the needs of the
              local community
            </p>
            <a href="#" className="btn">
              Join Our Community
            </a>
            <div className="join-our-img">
              <img src={join1} alt="img" />
              <img src={join2} alt="img" />
              <img src={join3} alt="img" />
              <img src={join4} alt="img" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Community;
